// Copyright (c) 2019-present Ladifire, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import React from 'react';
import classNames from 'classnames';

import styles from '../../styles/components/button/style.scss';

interface Props {
    children: React.ReactNode;
    fit: boolean;
    onClick?: React.MouseEventHandler;
    testId?: string;
}

export default ({fit, children, ...rest}: Props) => (
    <span
        className={classNames(styles.button__inner_wrapper, {
            [styles.fit_container]: fit,
        })}
        {...rest}
    >
        {children}
    </span>
);
